import { render } from "./DuelsControls.vue?vue&type=template&id=4f4e69b1&scoped=true"
import script from "./DuelsControls.vue?vue&type=script&lang=js"
export * from "./DuelsControls.vue?vue&type=script&lang=js"

import "./DuelsControls.vue?vue&type=style&index=0&id=4f4e69b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4e69b1"]])

export default __exports__